import React from "react";
import classes from "./logo.module.css";

const SidebarLogo = () => {
   return <div className={classes.container}>
       <img src="/images/urbc-logo-white.png" alt="URBC Logo" className={classes.logo}/>
   </div>;
};

export default SidebarLogo;
